/**
 * Frontend configuration with runtime environment detection.
 *
 * For SEO purposes (canonical URLs, og:url, etc.), we need the production URL
 * during react-snap pre-rendering. At runtime in the browser, we use the
 * actual origin for API calls.
 */

// Production URL for SEO meta tags (used during pre-rendering and in production)
const PRODUCTION_URL = 'https://itineraryseek.com';

// Check if we're in a browser and on a real domain (not localhost)
const isProductionBrowser = typeof window !== 'undefined' &&
  window.location.hostname !== 'localhost' &&
  !window.location.hostname.includes('127.0.0.1');

// For SEO tags, always use production URL (important for react-snap pre-rendering)
export const SEO_BASE_URL = PRODUCTION_URL;

// For API calls, use the actual origin in browser, or production URL as fallback
const BASE_URL = isProductionBrowser ? window.location.origin : PRODUCTION_URL;

export default BASE_URL;
